import { machineTypeSchema } from "@packsize/schemas/machines";

export const X7_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.X7 }] as const;
